export default __webpack_public_path__ + "static/media/59.a53fd522.png";